const benefitsAnimation = {
    init: () => {
        function startAnimation(element, endValue, hasPercentage) {
            let currentValue = 0;
            const step = Math.ceil(endValue / 100);
            const interval = setInterval(() => {
                if (currentValue + step >= endValue) {
                    currentValue = endValue;
                    clearInterval(interval);
                } else {
                    currentValue += step;
                }
                element.textContent = currentValue + (hasPercentage ? "%" : "");
            }, 20);
        } 

        function handleIntersection(entries, observer) {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const element = entry.target;
                    const textContent = element.textContent.trim();
                    const endValue = textContent.includes("%") ? parseInt(textContent.replace(/\D/g, ''), 10) : parseFloat(textContent);
                    startAnimation(element, endValue, textContent.includes("%"));
                    observer.unobserve(element);
                }
            });
        }

        function observeIntersection() {
            const percentageElements = document.querySelectorAll(".lsg-benefits__info-percentige");
            const observer = new IntersectionObserver(handleIntersection, { threshold: 0.5 });
            percentageElements.forEach((element) => {
                observer.observe(element);
            });
        }

        // document.addEventListener("DOMContentLoaded", observeIntersection);
        observeIntersection()
    }
}

export default benefitsAnimation; 